import * as map from './data/map.json';
import {innerHTML, toggleClass, capitalize, innerHTMLTimeout, getLoadTimeParam} from './utils';
import * as bi from './bi';
import {useMobileVersion} from './config';
import header from './templates/header';
import footer from './templates/footer';
import * as headerMobileUtils from './templates/header/mobileUtils';
import * as headerDesktopUtils from './templates/header/desktopUtils';
import * as footerMobileUtils from './templates/footer/mobileUtils';
import cssHeaderMobile from './templates/header/mobile.scss';
import cssFooterMobile from './templates/footer/mobile.scss';
import cssHeaderDesktop from './templates/header/desktop.scss';
import cssFooterDesktop from './templates/footer/desktop.scss';
const css = {cssHeaderMobile, cssFooterMobile, cssHeaderDesktop, cssFooterDesktop};

export const renderTimeout = innerHTMLTimeout;

export const toString = (config = {}, translations = {}, user = null, location = null) => {
  const parts = ((config.hideHeaderAndFooter && []) || (config.useOnly && [config.useOnly]) || ['header', 'footer']);

  return parts
    .reduce((functions, part) => {
      const cssModule = css[`css${capitalize(part)}${capitalize(useMobileVersion(config) ? 'mobile' : 'desktop')}`];
      functions[part] = {
        innerHTML: () => ({header, footer})[part]({map, translations, isMobile: useMobileVersion(config), config, user, location}),
        className: cssModule.container
      };
      return functions;
    }, {});
};

export default function (nodes, config, translations, user) {
  const parts = toString(config, translations, user, window.location);
  const isMobile = useMobileVersion(config);

  Object.keys(parts).forEach(part => {
    const cssModule = css[`css${capitalize(part)}${capitalize(isMobile ? 'mobile' : 'desktop')}`];
    if (config.hostPage && cssModule[config.hostPage]) {
      toggleClass(document.body, cssModule[config.hostPage], true);
    }
    const containerAttributes = {role: 'navigation'};
    if (isMobile) {
      containerAttributes.ontouchstart = '';
    }
    innerHTML(nodes[part],
      parts[part].innerHTML(),
      parts[part].className,
      config.language,
      containerAttributes);
  });

  setTimeout(() => {
    if (isMobile) {
      headerMobileUtils
        .markCurrentMenuItem()
        .bindStateChangeListener()
        .bindClicks()
        .preventSafariBackButtonCache();

      footerMobileUtils
        .removeHiddenClassHackForEditorsSites()
        .removeAttributeFromLinks();
    } else {
      headerDesktopUtils
        .markCurrentMenuItem()
        .makeDropdownsAccessible()
        .bindClicks();
    }
    bi.headerAndFooterBiLogger.log({
      evid: bi.hfBiConfig.loadComplete,
      is_mobile: isMobile, // eslint-disable-line
      component: 'header',
      ...getLoadTimeParam()
    });
  }, renderTimeout);
}

export function updateProfileImage(src, config) {
  const isMobile = useMobileVersion(config);
  const image = document.getElementById(css[`cssHeader${isMobile ? 'Mobile' : 'Desktop'}`].profileImage);
  if (image) {
    image.src = src;
  }
}
